import { useCallback, useEffect, useState } from "react";

import { getExhClient, isExhClientInitialized } from "../client";
import { ExhApiError, ExhUserListItem } from "../types";
import { parseExhError } from "../utils";

interface UseExhUsersResult {
  users: ExhUserListItem[];
  isLoading: boolean;
  error: ExhApiError | null;
  refetch: () => Promise<void>;
}

export const useExhUsers = (): UseExhUsersResult => {
  const [users, setUsers] = useState<ExhUserListItem[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(isExhClientInitialized());
  const [error, setError] = useState<ExhApiError | null>(null);

  const fetchUsers = useCallback(async () => {
    if (!isExhClientInitialized()) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const client = getExhClient();
      const result = await client.users.staff();
      setUsers(result?.data ?? []);
    } catch (err) {
      setError(parseExhError(err));
      setUsers([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return { users, isLoading, error, refetch: fetchUsers };
};
